export default "__VITE_ASSET__c799e049__"